Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.DeliveryAlert = {
  template: () => ({
    tag: 'div',
    items: [
      {
        items: [
          {
            items: [
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'checkbox',
                          id: 'toCurrentCustomerSMS',
                          name: 'check_sms',
                          class: 'modelAttribute'
                        }
                      }
                    ]
                  }
              ],
              attributes: {
                  class: 'control-label-delivery-alert'
                }
              },
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.label',
                    attributes: {
                      class: 'i18nResource'
                    }
                  }
                ],
                attributes: {
                  class: 'control-label-delivery-alert',
                  for: 'toCurrentCustomerSMS'
                }
              }
            ],
            attributes: {
              class: 'control-checkbox-delivery-alert'
            }
          }
        ]
      },
      {
        items: [
          {
            tag: 'textarea',
            attributes: {
              cols: '110',
              rows: '4',
              name: 'action_sms_text',
              id: 'action_delivery_alert_textarea',
              class: 'modelAttribute textAreaField mandatory autocomplete_entity',
              maxlength: '1414'
            }
          },
          {
            items: [
              {
                tag: 'input',
                attributes: {
                  type: 'button',
                  id: 'DeliveryAlertSMSButtonLink',
                  class: 'controls',
                  name: 'btn_add_link',
                  value: Monet.I18n.getResourcesByKey('event.insertDownloadLink.label')
                }
              }
            ]
          }
        ],
        attributes: {
          class: 'controls',
          id: 'sms-delivery'
        }
      },
      {
        items: [
          {
            items: [
              {
                  items: [
                      {
                          tag: 'label',
                          items: [
                              {
                                  tag: 'input',
                                  attributes: {
                                      type: 'checkbox',
                                      id: 'DeliveryAlertEmailCheckbox',
                                      name: 'check_email',
                                      class: 'modelAttribute'
                                  }
                              }
                          ]
                      }
                  ],
                  attributes: {
                      class: 'control-label-delivery-alert'
                  }
              },
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.email.label',
                    attributes: {
                      class: 'i18nResource'
                    }
                  }
                ],
                attributes: {
                  class: 'control-label-delivery-alert',
                  id: 'DeliveryAlertEmailLabel',
                  for: 'DeliveryAlertEmailCheckbox'
                }
              }
            ],
            attributes: {
              class: 'control-checkbox-delivery-alert',
              id: 'email_label'
            }
          }
        ]
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.email.from',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          id: 'delivery_alert_action_from_label',
          for: 'delivery_alert_action_from_field',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'text',
              maxlength: '120',
              name: 'delivery_alert_action_from_field',
              id: 'delivery_alert_action_from_field',
              class: 'modelAttribute textField mandatory',
              autocomplete: 'off',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.email.subject',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'delivery_alert_action_subject',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'text',
              maxlength: '80',
              name: 'delivery_alert_action_subject',
              id: 'delivery_alert_action_subject',
              class: 'modelAttribute textField mandatory',
              autocomplete: 'off',
            },
          }
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
        {
          tag: 'span',
          html: 'event.email.body',
          attributes: {
            class: 'i18nResource',
          }
        },
      ],
        attributes: {
          class: 'control-label',
          for: 'action_delivery_email_body',
        },
      },
      {
        items: [
          {
            items: [
              {
                attributes: {
                  id: 'action_delivery_email_body',
                },
              },
            ],
            attributes: {
              id: 'delivery_alert_action_email_body_container',
            },
          },
          {
              tag: 'input',
              attributes: {
                  type: 'button',
                  id: 'DeliveryAlertEmailButtonLink',
                  class: 'controls',
                  name: 'btn_add_link',
                  value: Monet.I18n.getResourcesByKey('event.insertDownloadLink.label')
              }
          },
        ],
          attributes: {
          class: 'controls deliveryEmail',
          id: 'email-delivery'
        }
      },
    ]
  }),

  addListenerSMS: () => {
    const inputTo = document.querySelector('#action_delivery_alert_textarea');

    inputTo.addEventListener('change', (e) => {
      inputTo.className = 'modelAttribute textField mandatory';
      inputTo.innerHTML = e.target.value;
    });
  },

  prepareDeliveryAlertAction: () => {
    const buttonSMS = document.getElementById('DeliveryAlertSMSButtonLink');
    const buttonEmail = document.getElementById('DeliveryAlertEmailButtonLink');
    const smsField = document.getElementById('action_delivery_alert_textarea');
    const smsDefaultText = Monet.I18n.getResourcesByKey('event.invitation.myorder.text.sms');
    const emailDefaultText = Monet.I18n.getResourcesByKey('event.invitation.myorder.text.email');
    const insertLinkText = '@myorder.link@';
    const inputSMSCheckBox = document.querySelector('input[name="check_sms"]#toCurrentCustomerSMS');
    const smsBodyField = document.querySelector('#action_delivery_alert_textarea');
    const inputEmailCheckBox = document.querySelector('#DeliveryAlertEmailCheckbox');
    const emailFromField = document.getElementById('delivery_alert_action_from_field');
    const emailSubjectField = document.querySelector('#delivery_alert_action_subject');
    const emailDropDownAddAttribute = document.querySelector('#delivery_alert_action_email_body_container > div.ql-toolbar.ql-snow > div > div > button');
    const emailBodyArea = document.querySelector('.controls.deliveryEmail#email-delivery');
    const emailBodyField = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor;

    buttonSMS.setAttribute('disabled', '');
    smsBodyField.setAttribute('disabled', '');

    emailBodyField.disable();
    emailBodyField.container.firstElementChild.innerHTML = '';
    buttonEmail.setAttribute('disabled', '');
    emailFromField.setAttribute('disabled', '');
    emailFromField.value = '';
    emailSubjectField.setAttribute('disabled', '');
    emailFromField.setAttribute('disabled', '');
    emailDropDownAddAttribute.setAttribute('disabled', '');
    emailBodyArea.setAttribute('disabled', '');

    inputSMSCheckBox.addEventListener('click', (e) => {
      if (e.target.checked) {
        smsField.value = smsDefaultText;
        smsBodyField.removeAttribute('disabled');
        buttonSMS.removeAttribute('disabled');
        inputSMSCheckBox.setAttribute('checked', true);
      } else {
        smsField.value = '';
        smsBodyField.setAttribute('disabled', '');
        buttonSMS.setAttribute('disabled', '');
        inputSMSCheckBox.setAttribute('checked', false);
      }
    });

    buttonSMS.addEventListener('click', () => {
      if (inputSMSCheckBox.checked && !smsField.value.includes(insertLinkText)) {
        smsField.value = `${smsField.value} ${insertLinkText}`;
      }
    });

    inputEmailCheckBox.addEventListener('click', (e) => {
      if (e.target.checked) {
        emailBodyField.enable();
        emailBodyField.container.firstElementChild.innerHTML = emailDefaultText;
        buttonEmail.removeAttribute('disabled');
        emailFromField.removeAttribute('disabled');
        emailFromField.value = Monet.I18n.getResourcesByKey('event.action.email.from');
        emailSubjectField.removeAttribute('disabled');
        emailFromField.removeAttribute('disabled');
        emailDropDownAddAttribute.removeAttribute('disabled');
        emailBodyArea.removeAttribute('disabled');
        inputEmailCheckBox.setAttribute('checked', true);
      } else {
        emailBodyField.disable();
        emailBodyField.container.firstElementChild.innerHTML = '';
        buttonEmail.setAttribute('disabled', '');
        emailFromField.setAttribute('disabled', '');
        emailFromField.value = '';
        emailSubjectField.setAttribute('disabled', '');
        emailFromField.setAttribute('disabled', '');
        emailDropDownAddAttribute.setAttribute('disabled', '');
        emailBodyArea.setAttribute('disabled', '');
        inputEmailCheckBox.setAttribute('checked', false);
      }
    });

    buttonEmail.addEventListener('click', () => {
      if (inputEmailCheckBox.checked) {
        emailBodyField.container.firstElementChild.firstElementChild.innerHTML = decodeURI(`${emailBodyField.container.firstElementChild.firstElementChild.innerHTML} ${insertLinkText}`);
      }
    });
  },

  initializeDeliveryRichTextComponent: (editorSelector) => {
    const toolbarOptions = [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }]
    ];
    const deliveryAlertQuill = new Quill(editorSelector, {
      modules: {
        toolbar: toolbarOptions
      },
      theme: 'snow'
    });
    return deliveryAlertQuill;
  },

  prepareAutoComplete: (selector) => {
    const REGEX = /(@(?:(?:\w|\d|\.)+)(?!\w|\d|\.))[^@]/;
    $(`${selector} .ql-editor`).on("keypress", () => {
      $(`${selector} .ql-editor`).on('keydown', (event) => {
        if (event.keyCode === $.ui.keyCode.TAB && $(this).data('autocomplete').menu.active) {
          event.preventDefault();
        }
      }).autocomplete({
        minLength: 0,
        source: (request, response) => {
          const richDeliveryEditor = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor;
          const text = richDeliveryEditor.container.firstElementChild.innerHTML;
          const terms = text.match(REGEX);
          if (terms) {
            const term = terms[1];
            response($.ui.autocomplete.filter(
              Greenmile.Event.AutoComplete.autoCompleteTags,
              Greenmile.Event.AutoComplete.extractLast(
                term.replace('@', ''))
              )
            );
          } else {
            response();
          }
        },
        focus: () => (false),
        select: (event, ui) => {
          const richDeliveryEditor = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor;
          const matched = richDeliveryEditor.getText().match(REGEX);
          if (matched) {
            const pattern = matched[1];
            richDeliveryEditor.deleteText(matched.index, pattern.length);
            richDeliveryEditor.insertText(matched.index, ui.item.value);
          }
          return false;
        }
      });
    });
  },

  prepareBodyComponent: () => {
    const CONTAINER_SELECTOR = '.deliveryEmail .ql-toolbar.ql-snow';
    const deliveryAlertQuill = Greenmile.Actions.DeliveryAlert.initializeDeliveryRichTextComponent('#action_delivery_email_body');
    const container = document.querySelector(CONTAINER_SELECTOR);
    const selectFieldList = new Greenmile.Event.SelectFieldList(CONTAINER_SELECTOR);
    selectFieldList.setAvailableTags(Greenmile.Event.AutoComplete.loadEmailAvailableTags());

    App.Forms.Event.Actions = App.Forms.Event.Actions || {};
    App.Forms.Event.Actions.DeliveryAlert = App.Forms.Event.Actions.DeliveryAlert || {};
    App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor = deliveryAlertQuill;

    selectFieldList.addClickEventListener((field) => {
      if (field) {
        deliveryAlertQuill.insertText(deliveryAlertQuill.getText().length - 1, ` ${field.value}`, '', true);
      }
    });
    selectFieldList.render();

    container.appendChild(selectFieldList.elFieldList);
    Greenmile.Actions.DeliveryAlert.prepareAutoComplete('#action_delivery_email_body');
  },

  enableDeliveryAlertFields: () => {
    if (document.querySelector('input[name="check_sms"]#toCurrentCustomerSMS').checked) {
      const smsBodyField = document.querySelector('#action_delivery_alert_textarea');
      const buttonSMS = document.getElementById('DeliveryAlertSMSButtonLink');
      smsBodyField.removeAttribute('disabled');
      buttonSMS.removeAttribute('disabled');
    }
    if (document.querySelector('#DeliveryAlertEmailCheckbox').checked) {
      const buttonEmail = document.getElementById('DeliveryAlertEmailButtonLink');
      const emailFromField = document.querySelector('#delivery_alert_action_from_field');
      const emailSubjectField = document.querySelector('#delivery_alert_action_subject');
      const emailDropDownAddAttribute = document.querySelector('#delivery_alert_action_email_body_container > div.ql-toolbar.ql-snow > div > div > button');
      const emailBodyArea = document.querySelector('.controls.deliveryEmail#email-delivery');
      const emailBodyField = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor;
      emailBodyField.enable();
      buttonEmail.removeAttribute('disabled');
      emailFromField.removeAttribute('disabled');
      emailSubjectField.removeAttribute('disabled');
      emailFromField.removeAttribute('disabled');
      emailDropDownAddAttribute.removeAttribute('disabled');
      emailBodyArea.removeAttribute('disabled');
    }
  },

  assignParameter: (jsonParam) => {
    const data = (jsonParam) ? JSON.parse(jsonParam) : {};
    const param = data;

    if (data.toCurrentCustomerSMS) {
      document.querySelector('input[name="check_sms"]#toCurrentCustomerSMS').checked = true;
    }

    if (data.toCurrentCustomerEmail) {
      document.querySelector('#DeliveryAlertEmailCheckbox').checked = !!param.toCurrentCustomerEmail;
    }

    const inputToSMS = document.querySelector('#action_delivery_alert_textarea');
    inputToSMS.value = decodeURI(data?.text);

    document.querySelector('#delivery_alert_action_from_field').value = param.from || '';
    document.querySelector('#delivery_alert_action_subject').value = param.subject;
    document.querySelector('#action_delivery_email_body').value = param.body;

    const richDeliveryEditor = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor;

    if (!richDeliveryEditor.isEnabled()) {
      richDeliveryEditor.container.firstElementChild.innerHTML = '';
    }
    richDeliveryEditor.container.firstElementChild.innerHTML = decodeURI(param.body);

    Greenmile.Actions.DeliveryAlert.enableDeliveryAlertFields();
  },
  
  retrieveParameter: () => {
    const emailBody = encodeURI(App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor.container.firstElementChild.innerHTML);
    const smsTextArea = $('#action_delivery_alert_textarea')?.val();
    const encodedSmsTextArea = encodeURI(smsTextArea);

    const result = JSON.stringify({
      toCurrentCustomerSMS: document.querySelector('input[name="check_sms"]#toCurrentCustomerSMS').checked,
      toCurrentCustomerEmail: document.querySelector('#DeliveryAlertEmailCheckbox').checked,
      text: encodedSmsTextArea,

      from: $('#delivery_alert_action_from_field').val(),
      subject: $('#delivery_alert_action_subject').val(),
      body: emailBody
    });

    return result.replace(/\\"/g, '"');
  }
};
